import React from "react";
import ModalV2 from "../modalV2";
import { BORDER_SUCCESS, SUCCESS } from "../../../assets";

function SuccessModalV2({
  open,
  close,
  message,
  subtitle,
}: {
  open: boolean;
  close: () => void;
  message: string;
  subtitle?: string;
}) {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[430px]"
      edges="rounded-xl"
    >
      <div className="px-12 py-10 flex flex-col w-full items-center justify-center gap-y-3">
        <img src={BORDER_SUCCESS} className="w-[92px] h-[92px]" alt="" />
        <span className="text-[20px] font-semibold">{message}</span>
        {subtitle && (
          <span className="text-sm font-medium text-[#464255]">{subtitle}</span>
        )}

        <button
          onClick={close}
          className="bg-[#009444] w-full text-white px-10 py-3 rounded-xl"
        >
          Close
        </button>
      </div>
    </ModalV2>
  );
}

export default SuccessModalV2;
